import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 0,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    '&.MuiDrawer-paperAnchorDockedLeft': {
      borderRight: 'none',
    },

    [theme.breakpoints.up('sm')]: {
      width: theme.utils.desktopSidebarWidth.close,
    },
  },
  paper: {
    paddingTop: theme.spacing(15),
    border: 'none',
    width: 0,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 0),
      background: theme.palette.neutral.lightest,
      overflow: 'visible',
      width: theme.utils.desktopSidebarWidth.close,
      boxShadow: theme.shadows[1],
    },
  },
  drawerOpen: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: theme.utils.desktopSidebarWidth.open,
      '& $logoContainer': {
        paddingTop: theme.spacing(2.75),
      },
      '& $logo': {
        width: theme.spacing(7.5),
        height: theme.spacing(7.5),
      },
    },
  },
  logoContainer: {
    position: 'relative',
    height: theme.spacing(14),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    transition: theme.transitions.create('padding-top', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  logo: {
    display: 'block',
    margin: '0 auto',
    height: theme.spacing(5),
    width: theme.spacing(5),
    transition: theme.transitions.create(['height', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: '1',
  },
  navItem: {
    padding: theme.spacing(1, 3),
    marginBottom: theme.spacing(1),
    overflow: 'hidden',

    '&:hover, &:focus-visible': {
      background: 'transparent',
      color: theme.palette.primary.main,
    },

    '&.Mui-selected': {
      background: theme.palette.primary.main,
      color: theme.palette.neutral.white,
    },

    '&.Mui-selected:hover, &.Mui-selected:active, &.Mui-selected:focus-visible': {
      background: theme.palette.primary.dark,
    },
  },
  navItemPrinter: {
    margin: theme.spacing('auto', 0, 0),
  },
  navItemHelp: {
    margin: theme.spacing(0, 0, 0),
  },
  subNavItem: {
    paddingLeft: theme.spacing(5),
  },
  navIcon: {
    minWidth: 0,
    marginRight: theme.spacing(0.5),
    paddingLeft: 0,
    color: 'inherit',
    alignItems: 'center',

    '& svg': {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
  },
  navText: {
    overflow: 'hidden',
  },
  arrowIcon: {
    width: 20,
  },
  toggleButton: {
    position: 'absolute',
    right: theme.spacing(-2),
    bottom: theme.spacing(2.5),
    width: theme.spacing(4),
    height: theme.spacing(4),
    padding: 0,
    boxShadow: theme.shadows[1],
    background: theme.palette.neutral.white,
    color: theme.palette.neutral.main,

    '&:hover': {
      background: theme.palette.neutral.white,
    },

    '&:active, &.Mui-selected:focus-visible': {
      background: theme.palette.primary.main,
      '& svg': {
        color: theme.palette.neutral.white,
      },
    },

    '& svg': {
      height: theme.spacing(2),
      width: theme.spacing(2),
    },
  },
  toggleButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: theme.spacing(9),
    textAlign: 'right',
  },
}))

export default useStyles
